export const MAGNITUDE_UNITS = [
    'one',
    'thousand',
    'million',
    'billion',
    'trillion',
];

const magnitudeGenerator = (magnitude, i) => ({
    key: magnitude,
    value: Math.pow(1000, i),
});

export const MAGNITUDE_VALS = MAGNITUDE_UNITS.map(magnitudeGenerator);

/**
 * Determines the appropriate unit for a number
 *
 * @param  {Number} value Number to be formatted
 * @return {MAGNITUDE_UNITS} The magnitude to which it should be shrunk
 */
export function getUnit(value) {
    return MAGNITUDE_VALS[Math.floor(Math.log10(value) / 3)] || MAGNITUDE_VALS[0];
}

/**
 * Rounds the given value to the number of significant digits
 * @param {int} value - value to be formatted
 * @param {int} unit - what unit to divide the value by
 * @param {int} significantDigits - number of significant digits to show
 * @returns {String} shortened number with the number of specified significant digits but without the unit!
 */
export const roundValue = (value, unit, significantDigits = 2) => {
    // we don't need to do anything if the value is less than 1000
    if (value < 1000) {
        return value.toString();
    }

    unit = unit || getUnit(value).value;

    const roundedValue = value / unit;

    return Math.log10(roundedValue) > significantDigits ? Math.round(roundedValue).toString() : roundedValue.toPrecision(significantDigits);
};
